import { useEffect, useState } from "react";
import styles from "./CustomerOrdersPage.module.scss";
import moment from "moment";
import CommonPagination from "../../../common/components/pagination/CommonPagination";
import { useGetCustomerOrdersQuery } from "../../../service/customer/customer-orders-service";
import OrderDetailsSideDialog from "./components/OrderDetailsSideDialog/OrderDetailsSideDialog";

const CustomerOrdersPage = () => {
	const [orderId, setOrderId] = useState("");
	const pageSize = 6;
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(3);

	const { data, isLoading, refetch } = useGetCustomerOrdersQuery({
		page: currentPage,
		pageSize,
	});

	useEffect(() => {
		if (data) {
			setTotalPages(data.totalPages);
		}
	}, [data]);

	return (
		<div className={styles.ordersWrapper}>

			<div className={styles.pageHeader}>
				<h2>Orders</h2>
			</div>
			<div className={styles.tableContainer}>
				<table className="standardTable">
					<thead>
						<tr>
							<th>PRODUCT NAME</th>
							<th>PAYMENT STATUS</th>
							<th>NEXT DUE DATE</th>
							<th>LAST PAYMENT DATE</th>
							<th>ORDER NUMBER</th>
							<th>ORDER STATUS</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{data?.items?.map((item, index) => (
							<tr key={index}>
								<td>{item.productName || "-"}</td>
								<td>{item.paymentStatus || "-"}</td>
								<td>{item.nextDueDate ? moment(item.nextDueDate).format("Do MMM, YYYY") : "-"}</td>
								<td>{item.lastPaymentDate ? moment(item.lastPaymentDate).format("Do MMM, YYYY") : "-"}</td>
								<td className={styles.orderNum}>{item.orderNumber || "-"}</td>
								<td>{item.orderStatus || "-"}</td>
								<td
									className={styles.viewDetails}
									onClick={() => {
										setOrderId(item.id);
									}}
								>
									view details
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className={styles.paginationContainer}>
				<CommonPagination
					currentPage={currentPage}
					isLoading={isLoading}
					numberOfPages={totalPages}
					onPageChange={(page: number) => {
						setCurrentPage(page);
					}}
				/>
			</div>

			{!!orderId && <OrderDetailsSideDialog orderId={orderId} onCloseDialog={() => setOrderId("")} />}
		</div>
	);
};

export default CustomerOrdersPage;
